// @flow
import Enum from 'common/enums/Enum';

export const ZoneMapGeometryTypeEnum = new Enum({
    Point: 'POINT',
    Polyline: 'MULTIPOINT_LINE',
    DirectedPolyline: 'MULTIPOINT_DIRECTED_LINE',
    Polygon: 'POLYGON',
    Circle: 'CIRCLE'
});
